import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { carouselNews } from 'src/app/shared/models/node';
import { NavigationService } from 'src/app/shared/services/navigation.service';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {
  @Input() block: any;
  public carouselNews: any;
  public domainWebsite = environment.urlApi;
  public customOptionsOwl: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    margin: 10,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true
  };

  constructor(
    private nodeService: NodeService,
    public helpersService: HelpersService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.getResults();
  }

  private getResults() {
    this.nodeService.getLastResults(this.helpersService.langCodeApi, this.block.tipo_view, this.block.preview).subscribe((res: carouselNews[]) => {
      this.carouselNews = res;
    })
  }

}
